var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "modal-dialog modal-lg", attrs: { role: "document" } },
    [
      _c("div", { staticClass: "modal-content" }, [
        _c("div", { staticClass: "modal-header" }, [
          _c(
            "h3",
            { staticClass: "modal-title", attrs: { id: "exampleModalLabel" } },
            [_vm._v("Order Reciept")]
          ),
          _c("button", {
            ref: "close",
            staticClass: "btn-close",
            attrs: {
              type: "button",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
            },
          }),
        ]),
        _c("div", { staticClass: "modal-body" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body mx-4" }, [
              _c("div", { staticClass: "container" }, [
                _c(
                  "p",
                  { staticClass: "my-4", staticStyle: { "font-size": "30px" } },
                  [_vm._v("Checkout Order")]
                ),
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("ul", { staticClass: "list-unstyled" }, [
                      _c("li", { staticClass: "text-muted mt-1 h4" }, [
                        _c("span", { staticClass: "text-black h4" }, [
                          _vm._v("Invoice:"),
                        ]),
                        _vm._v(" " + _vm._s(_vm.order.readable_ID)),
                      ]),
                    ]),
                    _c("hr"),
                    _vm._l(_vm.$props.order.item_list, function (item, index) {
                      return _c("div", { key: index, staticClass: "row" }, [
                        _c("div", { staticClass: "col-9" }, [
                          _c("p", [
                            _vm._v(
                              _vm._s(item.numberOfDrinks + " x " + item.name) +
                                " "
                            ),
                            _c("span", { staticStyle: { color: "grey" } }, [
                              _vm._v(
                                _vm._s(
                                  " ($" + item.cost_with_tax.toFixed(2) + ")"
                                )
                              ),
                            ]),
                          ]),
                          item.specialInstructions
                            ? _c("p", { staticClass: "ms-4" }, [
                                _c("b", [_vm._v("Special Instructions: ")]),
                              ])
                            : _vm._e(),
                          item.specialInstructions
                            ? _c("p", { staticClass: "ms-4" }, [
                                _vm._v(_vm._s(item.specialInstructions)),
                              ])
                            : _vm._e(),
                          item.additionalInfo
                            ? _c(
                                "div",
                                { staticClass: "ms-4" },
                                [
                                  _vm._m(0, true),
                                  _vm._l(
                                    item.additionalInfo,
                                    function (info, key) {
                                      return _c(
                                        "div",
                                        {
                                          key: key,
                                          staticClass:
                                            "additional-info margin-xl-left-header",
                                        },
                                        _vm._l(
                                          info,
                                          function (dataItem, subKey) {
                                            return _c(
                                              "p",
                                              {
                                                key: subKey,
                                                staticClass:
                                                  "additional-item-text",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "bold-text" },
                                                  [_vm._v(_vm._s(subKey))]
                                                ),
                                                _vm._v(
                                                  " - $" +
                                                    _vm._s(
                                                      parseFloat(
                                                        dataItem.cost
                                                      ).toFixed(2)
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    }
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                        ]),
                        _c("div", { staticClass: "col-3" }, [
                          _c("p", { staticClass: "float-end" }, [
                            _vm._v(
                              "$ " +
                                _vm._s(_vm.getFullItemCost(item).toFixed(2)) +
                                " "
                            ),
                          ]),
                        ]),
                        index != _vm.$props.order.item_list.length - 1
                          ? _c("hr")
                          : _vm._e(),
                      ])
                    }),
                    _c("hr", { staticStyle: { border: "2px solid black" } }),
                  ],
                  2
                ),
                _c("div", { staticClass: "row text-black" }, [
                  _c("div", { staticClass: "col-xl-12" }, [
                    _c("p", { staticClass: "float-end" }, [
                      _vm._v(
                        "Sub Total: $" +
                          _vm._s(_vm.getSubTotal().toFixed(2)) +
                          " "
                      ),
                    ]),
                  ]),
                  _vm.$props.order.payment_ID
                    ? _c("div", { staticClass: "col-xl-12" }, [
                        _c("p", { staticClass: "float-end" }, [
                          _vm._v(
                            "Platform Fee: $ " +
                              _vm._s(_vm.platformFee(_vm.order.total_cost)) +
                              " "
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.$props.order.stripe_tip_amount
                    ? _c("div", { staticClass: "col-xl-12" }, [
                        _c("p", { staticClass: "float-end" }, [
                          _vm._v(
                            "Tip: $ " +
                              _vm._s(
                                _vm.toDollarAmount(_vm.order.stripe_tip_amount)
                              ) +
                              " "
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "col-xl-12" }, [
                    _c("p", { staticClass: "float-end fw-bold" }, [
                      _vm._v(
                        "Total: $ " +
                          _vm._s(_vm.toDollarAmount(_vm.order.total_cost)) +
                          " "
                      ),
                    ]),
                  ]),
                  _c("hr", { staticStyle: { border: "2px solid black" } }),
                ]),
              ]),
              _vm.$props.order.acceptance_notes &&
              _vm.$props.order.acceptance_notes.trim() !== ""
                ? _c("div", { staticClass: "form-group" }, [
                    _c("h4", [_vm._v("Acceptance Notes:")]),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.$props.order.acceptance_notes,
                          expression: "$props.order.acceptance_notes",
                        },
                      ],
                      staticClass: "notes-box",
                      attrs: { disabled: "" },
                      domProps: { value: _vm.$props.order.acceptance_notes },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.$props.order,
                            "acceptance_notes",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ])
                : _vm._e(),
              _vm.$props.order.cancel_reason &&
              _vm.$props.order.cancel_reason.trim() !== ""
                ? _c("div", { staticClass: "form-group" }, [
                    _c("h4", [_vm._v("Cancel Reason:")]),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.$props.order.cancel_reason,
                          expression: "$props.order.cancel_reason",
                        },
                      ],
                      staticClass: "notes-box",
                      attrs: { disabled: "" },
                      domProps: { value: _vm.$props.order.cancel_reason },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.$props.order,
                            "cancel_reason",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
        !_vm.$props.order.is_cancelled && _vm.order.payment_intent_ID
          ? _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  attrs: { type: "button" },
                  on: { click: _vm.refundOrder },
                },
                [_vm._v("Refund Order")]
              ),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("b", [_vm._v("Additional Info: ")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }